import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { EMPTY, iif, of } from 'rxjs';
import { map, mergeMap, withLatestFrom, catchError } from 'rxjs/operators';

/* notification service */
import { NotificationService } from 'src/app/features/shared/services/notification-service/notification.service';

/* jsonata object class */
import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* lodash lib */
import * as lodash from 'lodash';

/* DataStorage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

/* navigate action */
import { Navigate } from 'src/app/features/data-stores/router-data-store/state/router-data-store.actions';

/* Workflow Management API Service */
import { WorkflowManagementControllerService } from 'src/app/features/shared/sdk/services/workflow-management-controller.service';

/* member-data-store actions */
import * as MemberDataStoreActions from 'src/app/features/data-stores/member-data-store/state/member-data-store.actions';

/* api services */
import { AdminUserControllerService } from '../services/admin-user-controller.service';

export const navigatePathAfterCreatingInstance = '/members/';
export const navigatePathAfterUpdatingInstance = '/members/';
@Injectable()
export class MemberDataStoreEffects {
  constructor(
    private actions$: Actions,
    private store: Store<DataStorage>,
    private notificationService: NotificationService,
    private workflowManagementApi: WorkflowManagementControllerService,
    private adminUserControllerService: AdminUserControllerService,
  ) { 
    // prettier-ignore
    // #region customCode: data-store-effects__constructor__start
    
    // #endregion customCode: data-store-effects__constructor__start

    // prettier-ignore
    // #region customCode: data-store-effects__constructor__end
    
    // #endregion customCode: data-store-effects__constructor__end
  }

  // GetActiveMemberId$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(MemberDataStoreActions.InitFetchingActiveMemberWithRelations),
  //     withLatestFrom(
  //       this.store.select((state) => state.RouterDataStore.params),
  //     ),
  //     /* dataset */
  //     mergeMap(([action, params]) => {
  //       const data = {
  //         eventPayload: action['payload'] ?? {},
  //         params,
  //       };
  //       const initialPayload = of(JSONAtaObject.chain(data));
  //       return initialPayload;
  //     }),

  //     // prettier-ignore
  //     // #region customCode: data-store-effects__pre-data-transformation__start

  //     // #endregion customCode: data-store-effects__pre-data-transformation__start

  //     /* pre data transformation */
  //     mergeMap(payloadAsJsonataObj => {
  //           /* Pre Data Transformation Step 1 ( Map ) */
  //           /* get value of the passed jsonata object */
  //           const data = <any>payloadAsJsonataObj.value;
  //           /* transform data */
  //           const transformedData = JSONAtaObject.chain(data).transform(`
  //             { "id": params.id }
  //           `);
  //           return transformedData;
  //         }),
  //     // prettier-ignore
  //     // #region customCode: data-store-effects__pre-data-transformation__end

  //     // #endregion customCode: data-store-effects__pre-data-transformation__end
  //     /* trigger success actions */
  //     mergeMap((jsonataObj) => {
  //           /* get value of the passed jsonata object */
  //           const data = <any>jsonataObj.value;
  //           return [
  //             MemberDataStoreActions.GetActiveMemberWithRelationsById({ payload: data }),
  //             ];
  //         }),
  //   ),
  // );

  getMembers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberDataStoreActions.GetMembers),
      mergeMap((action) => {
        return this.adminUserControllerService.getUsers().pipe(
          mergeMap((users: any[]) => {
            const payload: any = {
              members: users,
            };
            return [MemberDataStoreActions.GetMembersSuccessful({ payload })];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while fetching data.',
            );
            return [MemberDataStoreActions.GetMembersFailure()];
          }),
        );
      }),
    ),
  );



  getActionLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberDataStoreActions.GetActionLogs),
      mergeMap((action) => {
        return this.adminUserControllerService.getUserActionLogs().pipe(
          mergeMap((actionLogs: any[]) => {
            const payload: any = {
              actionLogs: actionLogs,
            };
            return [MemberDataStoreActions.GetActionLogsSuccessful({ payload })];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while fetching data.',
            );
            return [MemberDataStoreActions.GetMembersFailure()];
          }),
        );
      }),
    ),
  );

  // getMemberById$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(MemberDataStoreActions.GetMemberById),
  //     mergeMap((action) => {
  //       return this.memberApiService
  //         .findById({
  //           id: action.payload.id,
  //         })
  //         .pipe(
  //           mergeMap((member) => {
  //             const payload: any = {
  //               member: member,
  //             };
  //             return [
  //               MemberDataStoreActions.GetMemberByIdSuccessful({ payload }),
  //             ];
  //           }),
  //           catchError((error) => {
  //             this.notificationService.createNotification(
  //               'error',
  //               'Failure',
  //               'There was an error while fetching data.',
  //             );
  //             return [MemberDataStoreActions.GetMemberByIdFailure()];
  //           }),
  //         );
  //     }),
  //   ),
  // );


  createMember$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberDataStoreActions.CreateMember),
      mergeMap((action) => {
        const params = {
          ...action?.payload?.member ?? {},
        };
        return this.adminUserControllerService.createUser(<any>params).pipe(
          mergeMap((member) => {
            this.notificationService.createNotification(
              'success',
              'Successful',
              'Your data has been saved successfully.',
            );
            const payload: any = {
              member: member,
            };
            return [
              MemberDataStoreActions.CreateMemberSuccessful({ payload }),
              MemberDataStoreActions.GetMembers(),
              Navigate({
                payload: { path: navigatePathAfterCreatingInstance },
              }),
            ];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while saving the data.',
            );
            return [MemberDataStoreActions.CreateMemberFailure()];
          }),
        );
      }),
    ),
  );

  // updateMember$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(MemberDataStoreActions.UpdateMember),
  //     mergeMap((action) => {
  //       const params = {
  //         id: action.payload.id,
  //         body: action.payload.data,
  //       };
  //       return this.memberApiService.updateById(<any>params).pipe(
  //         mergeMap(() => {
  //           this.notificationService.createNotification(
  //             'success',
  //             'Successful',
  //             'Your data has been updated successfully.',
  //           );
  //           return [
  //             MemberDataStoreActions.GetMembers(),
  //             Navigate({
  //               payload: { path: navigatePathAfterUpdatingInstance },
  //             }),
  //           ];
  //         }),
  //         catchError((error) => {
  //           this.notificationService.createNotification(
  //             'error',
  //             'Failure',
  //             'There was an error while updating the data.',
  //           );
  //           return [MemberDataStoreActions.UpdateMemberFailure()];
  //         }),
  //       );
  //     }),
  //   ),
  // );

  // deleteMember$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(MemberDataStoreActions.DeleteMember),
  //     mergeMap((action) => {
  //       const params = { id: action.payload.id };
  //       return this.memberApiService.deleteById(params).pipe(
  //         mergeMap(() => {
  //           this.notificationService.createNotification(
  //             'success',
  //             'Success',
  //             'Your data has been deleted successfully.',
  //           );
  //           const payload: any = {
  //             id: action.payload.id,
  //           };
  //           return [MemberDataStoreActions.DeleteMemberSuccessful({ payload })];
  //         }),
  //         catchError((error) => {
  //           this.notificationService.createNotification(
  //             'error',
  //             'Failure',
  //             'There was an error while deleting the data.',
  //           );
  //           return [MemberDataStoreActions.DeleteMemberFailure()];
  //         }),
  //       );
  //     }),
  //   ),
  // );
}
